import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import env from '../env';

const newsApi = createApi({
    reducerPath: 'news',
    baseQuery: fetchBaseQuery({
        baseUrl: env.baseUrl
    }),
    endpoints(builder) {
        return {
            getNews: builder.query({
                query: (params) => {

                    const category = params.id === 'all' ? '' : params.id;

                    return {
                        url: `/news/${category}?pageIdentifier=${params.pageIdentifier}`,
                        method: 'GET',
                    };
                },
                transformResponse: (posts) => {

                    posts.forEach(post => {
                        if (post.creationDate) {
                            post.creationDate = post.creationDate.substring(0, 10);
                        }
                    });

                    return posts;
                }
            }),
            getCounts: builder.query({
                query: () => {
                    return {
                        url: `/news/counts`,
                        method: 'GET',
                    };
                }
            }),
        };
    }
});

export const {
    useGetNewsQuery,
    useGetCountsQuery
} = newsApi;
export { newsApi };
